/**
 * Article metadata for the knowledge base.
 *
 * Discovered automatically by `generate-kb-catalog.mjs` (runs on `yarn start` and
 * `yarn build`). The slug must match this folder name.
 */
export const meta = {
  slug: 'angular-sdk',
  title: 'Angular SDK',
  category: 'SDKs & API',
  summary:
    'Report uncaught errors from an Angular app to PulseWatch: install, configure for standalone or NgModule apps, HTTP breadcrumbs, manual reporting and options.',
  keywords: ['Angular', 'SDK', 'ErrorHandler', 'providePulseWatch', 'PulseWatchModule', 'breadcrumbs', 'captureException'],
};

export const loadComponent = () => import('./angular-sdk.component').then((m) => m.AngularSdkArticleComponent);
